document.querySelectorAll('.swiper-product').forEach(function (sliderEl, index) {
    var slideCount = sliderEl.querySelectorAll('.swiper-slide').length;
    var wrapper = sliderEl.querySelector('.swiper-wrapper');

    function getSlidesPerView() {
        let w = window.innerWidth;
        if (w >= 1440) return 4;
        if (w >= 1000) return 3;
        if (w >= 768) return 2;
        return 1;
    }

    let slidesPerViewNow = getSlidesPerView();
    let enableLoop = slideCount > slidesPerViewNow;

    if (!enableLoop) {
        sliderEl.classList.add('loop-disabled');
    } else {
        sliderEl.classList.remove('loop-disabled');
    }

    if (wrapper) {
        if (slideCount > 0 && slideCount < slidesPerViewNow) {
            wrapper.classList.add('swiper-wrapper--centered');
        } else {
            wrapper.classList.remove('swiper-wrapper--centered');
        }
    }

    let swiper = new Swiper(sliderEl, {
        slidesPerView: 1,
        spaceBetween: 24,
        loopFillGroupWithBlank: false,
        loop: enableLoop,
        pagination: {
            el: sliderEl.querySelector('.swiper-pagination'),
            clickable: true,
        },
        navigation: enableLoop ? {
            nextEl: sliderEl.querySelector('.swiper-button-next'),
            prevEl: sliderEl.querySelector('.swiper-button-prev'),
        } : {},
        breakpoints: {
            1440: { slidesPerView: 4 },
            1000: { slidesPerView: 3 },
            768: { slidesPerView: 2 },
            480: { slidesPerView: 1 },
        },
        lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1,
        }
    });

    swiper.on('touchStart', function () {
        swiper.autoplay.stop();
    });
});




var swiper = new Swiper('.swiper-tr', {
    slidesPerView: 1.1,
    spaceBetween: 16,
    loop: true,
    pagination: {
        el: document.querySelector('.swiper-tr .swiper-pagination'),
        clickable: true,
    },
    breakpoints: {
        1440: { slidesPerView: 4, spaceBetween: 30 },
        1000: { slidesPerView: 3, spaceBetween: 30 },
        768: { slidesPerView: 2, spaceBetween: 30 },
        480: { slidesPerView: 1.2, spaceBetween: 16 },
    },
    lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
    }
});


var swiper = new Swiper('.swiper-review', {
    slidesPerView: 1,
    spaceBetween: 24,
    loop: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: null,
        prevEl: null,
    },
    breakpoints: {
        480: { slidesPerView: 1 },
        768: { slidesPerView: 1 },
        1200: { slidesPerView: 1 },
        1340: { slidesPerView: 1 },
    },
    lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
    }
});

function initSwiperBlock() {
    if (window.innerWidth < 1200) {
        new Swiper('.swiper-block', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    }
}

document.addEventListener('DOMContentLoaded', initSwiperBlock);
window.addEventListener('resize', initSwiperBlock);

function initSwiperCircle() {
    if (window.innerWidth < 1200) {
        new Swiper('.swiper-circle', {
            slidesPerView: 1,
            spaceBetween: 24,
            loop: false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    }
}

document.addEventListener('DOMContentLoaded', initSwiperCircle);
window.addEventListener('resize', initSwiperCircle);


document.addEventListener('DOMContentLoaded', function () {

    if (window.innerWidth > 768) return;

    const columns = document.querySelectorAll('.circle-num-block-column');
    let lastScrollTop = 0;

    if (!columns.length) return;

    columns[0].classList.add('active');

    window.addEventListener('scroll', () => {
        let scrollTop = window.scrollY || document.documentElement.scrollTop;

        columns.forEach((col, i) => {
            const rect = col.getBoundingClientRect();
            const triggerPoint = window.innerHeight * 0.69;

            if (rect.top < triggerPoint) {
                if (!col.classList.contains('visible')) {
                    col.classList.add('visible');

                    if (i > 0) {
                        const prevCol = columns[i - 1];
                        const prevHeight = prevCol.offsetHeight;


                        col.style.setProperty('--adjusted-margin', `-${prevHeight / 2}px`);
                        col.classList.add('margin-top-adjust');
                    } else {
                        col.classList.remove('margin-top-adjust');
                    }


                    col.classList.add('active');

                    columns.forEach((otherCol) => {
                        if (otherCol !== col) {
                            otherCol.classList.remove('active');
                        }
                    });
                }
            } else {
                if (scrollTop < lastScrollTop) {
                    col.classList.remove('visible');
                    col.classList.remove('margin-top-adjust');
                    col.style.removeProperty('--adjusted-margin');


                    col.classList.remove('active');
                }
            }
        });

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    });

    columns.forEach(col => {
        col.addEventListener('click', () => {
            columns.forEach(other => {
                other.classList.remove('visible', 'active', 'margin-top-adjust');
                other.style.removeProperty('--adjusted-margin');
            });

            col.classList.add('visible', 'active');
        });
    });
});


document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.swiper-blog', {
        loop: true,
        spaceBetween: 24,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        slidesPerView: 1,
    });
});


var swiper = new Swiper('.swiper-related-blogs', {
    slidesPerView: 1,
    spaceBetween: 24,
    loop: true,
    pagination: {
        el: '.swiper-related-blogs .swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-related-blogs .swiper-button-next',
        prevEl: '.swiper-related-blogs .swiper-button-prev',
    },
    breakpoints: {
        1440: { slidesPerView: 3 },
        1000: { slidesPerView: 2 },
        768: { slidesPerView: 1 },
    },
    lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
    }
});

document.addEventListener('DOMContentLoaded', function () {
    let teamSwiper = null;
    const breakpoint = 768;

    function initTeamSwiper() {
        const isMobile = window.innerWidth <= breakpoint;

        if (isMobile && !teamSwiper) {
            teamSwiper = new Swiper('.swiper-team', {
                slidesPerView: 1,
                spaceBetween: 16,
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 1
                }
            });
        }

        if (!isMobile && teamSwiper) {
            teamSwiper.destroy(true, true);
            teamSwiper = null;
        }
    }

    initTeamSwiper();
    window.addEventListener('resize', initTeamSwiper);
});

var swiper = new Swiper('.swiper-recs-product', {
    slidesPerView: 1,
    spaceBetween: 24,
    loop: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        1440: { slidesPerView: 3 },
        1340: { slidesPerView: 2 },
        900: { slidesPerView: 1 },
    },
    lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
    }
});

if (swiper) {
    swiper.on('touchStart', function () {
        swiper.autoplay.stop();
    });
}

document.addEventListener('DOMContentLoaded', function () {
    const swiperContainer = document.querySelector('.swiper-tile');
    if (!swiperContainer) {
        return;
    }

    const slides = swiperContainer.querySelectorAll('.product-tile');
    const swipes = swiperContainer.querySelectorAll('.swiper-slide');
    const slideCount = slides.length;

    if (slideCount >= 8) {
        const swiper = new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 16,
            loop: true,
            breakpoints: {
                640: { slidesPerView: 1 },
                768: { slidesPerView: 1 },
                1024: { slidesPerView: 1 },
                1280: { slidesPerView: 1 },
            },
            pagination: {
                el: swiperContainer.querySelector('.swiper-pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: swiperContainer.querySelector('.swiper-button-next'),
                prevEl: swiperContainer.querySelector('.swiper-button-prev'),
            }
        });

        swiper.on('touchStart', function () {
            swiper.autoplay.stop();
        });

    } else {
        swipes.forEach((slide, index) => {
            slide.style.display = index === 0 ? '' : 'none';
        });

        const pagination = swiperContainer.querySelector('.swiper-pagination');
        if (pagination) pagination.style.display = 'none';

        const prevArrow = swiperContainer.querySelector('.swiper-button-prev');
        const nextArrow = swiperContainer.querySelector('.swiper-button-next');
        if (prevArrow) prevArrow.style.display = 'none';
        if (nextArrow) nextArrow.style.display = 'none';

        const recommendationsContainer = document.querySelector('.main-cart__recommendations');
        if (recommendationsContainer) {
            recommendationsContainer.style.visibility = 'visible';
            recommendationsContainer.style.opacity = '1';
        }
    }
});


document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.testimonials-swiper', {
        slidesPerView: 1,
        spaceBetween: 24,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
});